import React from "react";
import HeroSlider from "../components/HeroSlider";
// import AboutSection from "../components/AboutSection";
import ServicesGrid from "../components/ServicesGrid";
import BlogList from "../components/BlogList";
import Testimonials from "../components/Testimonials";
import Footer from "../components/Footer";
import Quilt from "../components/ServiceRegions/İntros/Quilt";


const Home = () => {
  return (
    <> 
    <div>
        
      <HeroSlider />
      <Quilt/>
      <ServicesGrid />
      <BlogList/>
      <Testimonials/>
      <Footer/>
     
    </div>
     </>
  );
};

export default Home;